import { lazy as lazyLoad } from 'react';

import { route } from '../profile/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    EditSkillsPage: lazyLoad(async () => {
        const { EditSkillsPage } = await import('./EditSkills');

        return { default: EditSkillsPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-profile.skill-edit.headline',
        page: lazy.EditSkillsPage,
        path: route.patterns.individualUser.skills.edit,
    },
];
